<template>
  <div class="ds-custom-query-logic">
    <DsfCustomQueryLogicTree :data="data" :show-data-type="showDataType" :drag-proxy-append-to="dragProxyAppendTo"></DsfCustomQueryLogicTree>
  </div>
</template>
<script>

import DsfCustomQueryLogicTree from './cutsomQueryLogicTree.vue';
export default {
  name: "DsfCustomQueryLogic",
  
  components:{
    DsfCustomQueryLogicTree
  },
  provide() {
    return {
      $queryLogic: this
    };
  },
  props:{
    data:{
      type:Object,
      default(){
        return {}
      }
    },
    showDataType:{
      type:Boolean,
      default:false
    },
    dragProxyAppendTo:{
      type:[String,Function],
      default:""
    },
    getContainer:{
      type:Function,
      default(){
        return this.$el.parentNode;
      }
    }
  },
  data() {
    return {}
  },
  computed: {},
  beforeCreate() {},
  created() {
  },
  beforeMount() {},
  mounted() {},
  beforeDestroy() {},
  destroyed() {},
  methods: {
    // getContainer(){

      
    // },
    dragAutoScroll(dragPos){
      let box=$(this.getContainer());
      let boxHeight=box.height();
      let boxOffset = box.offset();
      if (boxOffset.top > dragPos.top) {
        box.scrollTop(box.scrollTop() - Math.abs(boxOffset.top - dragPos.top));
      } else if (boxOffset.top +boxHeight< dragPos.top) {
        box.scrollTop(box.scrollTop() + Math.abs((boxOffset.top+boxHeight) - dragPos.top));
      }
    }
  }
};
</script>